import  { useState } from "react";
import Header from "./components/Header";
import MovieBoxControls from "./components/MovieBoxControls";
import Movies from "./components/Movies";

const MovieBox = () => {
  const [stats] = useState({
    totalMovies: 4,
    totalViews: 0,
    totalEarnings: 0.0,
  });

  return (
    <div className="min-h-[calc(100vh-100px)] bg-gray-100 p-4 space-y-6">
      <Header stats={stats} />

      <div className="bg-white rounded-xl shadow p-6 w-full h-full flex flex-col">
        <MovieBoxControls />
        <Movies />
      </div>
    </div>
  );
};

export default MovieBox;
